import { useRef, useEffect } from 'react';
export const useDebounceScrollEvent = ({ scrollRef, onScroll, debounceTime = 300, }) => {
    const debounceTimer = useRef(null);
    useEffect(() => {
        const handleScrollEvent = () => {
            if (debounceTimer.current) {
                window.clearTimeout(debounceTimer.current);
            }
            debounceTimer.current = window.setTimeout(() => {
                onScroll();
            }, debounceTime);
        };
        const element = scrollRef.current;
        if (!element)
            return;
        element.addEventListener('wheel', handleScrollEvent, { passive: true });
        return () => {
            element.removeEventListener('wheel', handleScrollEvent);
            if (debounceTimer.current) {
                window.clearTimeout(debounceTimer.current);
            }
        };
    }, [scrollRef, onScroll, debounceTime]);
};
//# sourceMappingURL=use_debounce_scroll_event.js.map